"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParams = void 0;
const Util_1 = require("./Util");
const TypeaheadCategory_1 = require("./TypeaheadCategory");
const SortOption_1 = require("./SortOption");
const Template_1 = require("./Template");
const lookup = {
    allow_empty_search: Util_1.isBoolean,
    persist_query: Util_1.isBoolean,
    show_location: Util_1.isBoolean,
    sort_order: SortOption_1.isSortOptionArray,
    typeahead_categories: TypeaheadCategory_1.isTypeaheadCategoryArray,
    location_radius: Util_1.isNumber,
    template_name: Template_1.isValidTemplateName,
    filters: Util_1.isStringArray,
    or_filters: Util_1.isStringArray,
    not_filters: Util_1.isStringArray,
    open_results_in_new_tab: Util_1.isBoolean,
    focus_on_widget: Util_1.isBoolean,
    use_specialty_name_in_typeahead: Util_1.isBoolean,
    group_suggestions_by_category: Util_1.isBoolean,
    external_link: Util_1.isString
};
const isParams = (dict) => Object.entries(dict).every(([key, value]) => lookup[key] && lookup[key](value));
exports.isParams = isParams;
//# sourceMappingURL=Params.js.map